import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

import { ProcedureIndexStatusFilter } from "../interfaces";

export default {
  // ProcedureIndexStatusFilter.page is 0-indexed everywhere in this app's Redux state (matching
  // every other domain), but the backend's status endpoint is deliberately 1-indexed AND REQUIRES
  // both page and limit (api/app/shared/schemas/procedureIndexStatus.schemas.ts) — translate only
  // at this boundary, matching the eval run list's identical translation.
  getProcedureIndexStatus: (payload: ProcedureIndexStatusFilter) =>
    request(METHODS.GET, API.PROCEDURE_INDEX.GET_STATUS)({ params: { ...payload, page: payload.page + 1 } }),
};
